import avatar from '../assets/avatar.png';
import Bubble from '../components/Bubble';
import Waves from '../components/Waves';
import LinkBubble from '../components/LinkBubble';
import { useResponsiveView } from '../utils/fun';

export default function Hero() {
  
  const mobileViewEnabled = useResponsiveView();

  return (
    <section id="home" className="min-vh-100 d-flex align-items-md-center pt-sm-4 py-0 pt-lg-0"> 
      <div className="container-fluid">
        <div className="row min-vh-100 px-3 px-md-0">
          {/** Avatar */}
          <div className="col-12 col-md-6 order-2 order-md-1 d-flex justify-content-center align-items-md-center">
            <div className="avatar-wrap mx-2">
              <Bubble><img src={avatar} alt="Avatar" className="img-fluid" /></Bubble>
            </div>
          </div>
          {/** Intro Text */}
          <div className="col-12 col-md-6 order-1 order-md-2 d-flex flex-column justify-content-center pt-5 pt-md-0 pb-0 pb-md-5">
            <p className="m-0 fs-3">Hi! I'm Yu,</p>
            <h1 className="m-0 fw-bold display-3">Marco Jalen Yu</h1>
            <p className="m-0 fs-5 pb-0 pb-md-5">A Software Engineer.</p>
          </div>
        </div>
      </div>      
      <Waves compact={mobileViewEnabled} />
      {/** Socials */}
      <div className="d-flex bottom-0 end-0 mx-3 my-4 gap-3 position-absolute">
        <LinkBubble href="mailto:marcojalenyu@gmail.com" ariaLabel="Send Email">
          <i className="bi bi-envelope"></i>
        </LinkBubble>
        <LinkBubble href="https://www.linkedin.com/in/marcojalenyu/" ariaLabel="Open LinkedIn">
          <i className="bi bi-linkedin"></i>
        </LinkBubble>
        <LinkBubble href="https://github.com/marcojalenyu" ariaLabel="Open GitHub">
          <i className="bi bi-github"></i>
        </LinkBubble>
      </div>
    </section> 
  );
}